import React, { useState } from "react";
import DialogComponent from "../components/DialogComponent";
import PropTypes from "prop-types";

const Apikey = ({ setDailog }) => {
  const [apikey, setApikey] = useState(localStorage.getItem("apikey") || "");
  const [account, setAccount] = useState(
    localStorage.getItem("accountId") || ""
  );
  const [apiEndpoint, setApiEndpoint] = useState(
    localStorage.getItem("apiEndpoint") || window.config?.apiEndpoint
  );
  const [phonenumber, setPhonenumber] = useState(
    localStorage.getItem("callerId")||''
  );

  const handleConfChange = (e) => {
    if (e.target.name === "apiKey") {
      setApikey(e.target.value);
    }
    if (e.target.name === "account") {
      setAccount(e.target.value);
    }
    if (e.target.name === "apiEndpoint") {
      setApiEndpoint(e.target.value);
    }
     if (e.target.name === "phonenumber") {
      setPhonenumber(e.target.value);
     }
  };

  const handleEndpointClear = () => {
    setApiEndpoint(window.config?.apiEndpoint);
  };
  function handleClick(event) {
    localStorage.setItem("apikey", apikey);
    localStorage.setItem("accountId", account);
    localStorage.setItem("apiEndpoint", apiEndpoint);
    localStorage.setItem("callerId", phonenumber);
    setDailog(false);
  }
  return (
    <>
      <DialogComponent
        handleClick={handleClick}
        handleChange={handleConfChange}
        data={account}
        apiKey={apikey}
        apiEndpoint={apiEndpoint}
        heading="Account Settings"
        ButtonName="Set"
        PlaceholderName="API Key"
        setDailog={setDailog}
        handleEndpointClear={handleEndpointClear}
        phonenumber={phonenumber}
      />
    </>
  );
};
Apikey.propTypes = {
  setDailog: PropTypes.any,
};
export default Apikey;
